import Vue from "vue"
import {Component} from "vue-property-decorator";
import {getOutputTemplateById} from "@/api/classManage";
import commonData from "@/utils/commonData";

Vue.filter('getCourseTypeName', function (value) {
    if (value) {
        return commonData.projectTypeArray.find(item => item.value === value).label
    }
});
@Component({})
export default class ProduceMouldInfo extends Vue {
    // data
    infoData: any = {}
    id = null

    /**/
    created() {
        this.id = this.$route.query.id
        this.getDataInfo()
    }

    /**/
    getDataInfo() {
        getOutputTemplateById(this.id).then((res: any) => {
            this.infoData = res.outputTemplate
            if (this.infoData.ccStr) {
                this.infoData.ccStr = this.infoData.ccStr.replace('${thesisUserId}', '<span class="el-tag el-tag--light">论文班主任</span>')
                this.infoData.ccStr = this.infoData.ccStr.replace('${helperUserId}', '<span class="el-tag el-tag--light">小助手</span>')
                this.infoData.ccStr = this.infoData.ccStr.replace('${teacherUserId}', '<span class="el-tag el-tag--light">班主任/项目负责人</span>')
                this.infoData.ccStr = this.infoData.ccStr.replace('${directorUserId}', '<span class="el-tag el-tag--light">订单负责人</span>')
            }
            if (this.infoData.bccStr) {
                this.infoData.bccStr = this.infoData.bccStr.replace('${thesisUserId}', '<span class="el-tag el-tag--light">论文班主任</span>')
                this.infoData.bccStr = this.infoData.bccStr.replace('${helperUserId}', '<span class="el-tag el-tag--light">小助手</span>')
                this.infoData.bccStr = this.infoData.bccStr.replace('${teacherUserId}', '<span class="el-tag el-tag--light">班主任/项目负责人</span>')
                this.infoData.bccStr = this.infoData.bccStr.replace('${directorUserId}', '<span class="el-tag el-tag--light">订单负责人</span>')

            }
            this.infoData.subjectStr = this.infoData.subjectStr.replace(/\${customerName}/g, '<span class="el-tag el-tag--light">学生姓名</span>')
            this.infoData.subjectStr = this.infoData.subjectStr.replace(/\${souCourseSchoolBegin}/g, '<span class="el-tag el-tag--light">开课时间</span>')
            this.infoData.subjectStr = this.infoData.subjectStr.replace(/\${souCourseName}/g, '<span class="el-tag el-tag--light">项目名称</span>')

            this.infoData.contentStr = this.infoData.contentStr.replace(/\${customerName}/g, '<span class="el-tag el-tag--light">学生姓名</span>')
            this.infoData.contentStr = this.infoData.contentStr.replace(/\${souCourseSchoolBegin}/g, '<span class="el-tag el-tag--light">开课时间</span>')
            this.infoData.contentStr = this.infoData.contentStr.replace(/\${souCourseName}/g, '<span class="el-tag el-tag--light">项目名称</span>')
        })
    }
}